import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fae9b64e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inner-container" }
const _hoisted_2 = {
  key: 0,
  class: "country-code-popup"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "country-code-popup-top" }, null, -1))
const _hoisted_4 = { class: "country-code-popup-inner" }
const _hoisted_5 = { class: "inner-content" }
const _hoisted_6 = { class: "items-container" }
const _hoisted_7 = ["onClick"]

import CountryCodeSearchBar from "@/components/forms/CountryCodeSearchBar.vue";

import { useGetCountryCodeSelectProperties } from "./useGetCountryCodeSelectProperties";
import Icon from "@/components/icons/Icon/Icon.vue";
import { IconType } from "@/types/icons";

interface CountryCodeSelectEmits {
  (e: "updateCountryCode", arg: string): void;
  (e: "togglePopup", arg: boolean): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CountryCodeSelect',
  emits: ["updateCountryCode", "togglePopup"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const { data, toggleDropdown, handleUpdateFilter, handleClick } =
  useGetCountryCodeSelectProperties(emit);

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "country-code-select",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(toggleDropdown) && _unref(toggleDropdown)(...args)))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", null, "+ " + _toDisplayString(_unref(data).selectedCountryCode), 1),
        _createVNode(Icon, {
          icon: _unref(IconType).DROPDOWN_ARROW,
          alt: "dropdown"
        }, null, 8, ["icon"])
      ])
    ]),
    (_unref(data).isPopupOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(CountryCodeSearchBar, { onUpdateFilter: _unref(handleUpdateFilter) }, null, 8, ["onUpdateFilter"]),
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).filteredCountryCodesArray, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.countryName + item.countryCode,
                    class: "country-code-item",
                    onClick: ($event: any) => (_unref(handleClick)(item))
                  }, [
                    _createElementVNode("h5", null, _toDisplayString(item.countryName), 1),
                    _createElementVNode("p", null, _toDisplayString(item.countryCode), 1)
                  ], 8, _hoisted_7))
                }), 128))
              ])
            ])
          ])), [
            [_directive_click_outside, _unref(toggleDropdown)]
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})